<template>
  <div>
    <!-- 页面加载状态 -->
    <div v-if="pageLoading" class="page-loading-wrapper">
      <van-loading size="32px" type="spinner" color="#1989fa">
        <span style="margin-top: 10px; display: block;">加载中...</span>
      </van-loading>
    </div>
    
    <!-- 表单内容 -->
    <van-form @submit="handleSubmit" v-else>
      <van-field v-model="formData.contactTypeLabel" label="电话号码" placeholder="请选择电话号码" readonly clickable
        @click="showContactTypePicker = true" />
      <van-popup v-model:show="showContactTypePicker" position="bottom">
        <van-picker :columns-field-names="contactTypeFieldName" :columns="phoneList" @confirm="onContactTypeConfirm"
          @cancel="showContactTypePicker = false" />
      </van-popup>

      <van-field v-model="formData.contactTypeLabel" label="电话号码" placeholder="请选择电话号码" readonly clickable
        @click="showContactTypePicker = true" />
      <van-popup v-model:show="showContactTypePicker" position="bottom">
        <van-picker :columns-field-names="contactTypeFieldName" :columns="phoneList" @confirm="onContactTypeConfirm"
          @cancel="showContactTypePicker = false" />
      </van-popup>

      <DictSelect
        v-model="formData.callStatus"
        name="callStatus"
        label="通话状态"
        placeholder="请选择通话状态"
        :columns="callStatusList"
        @confirm="(data) => { formData.callStatusLabel = data.label }"
      />

      <van-field v-model="formData.remark" label="备注" placeholder="请输入备注内容" type="textarea" rows="4" autosize
        :input-props="{ autocapitalize: 'none', autocorrect: 'off', autocomplete: 'off' }" />

      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>

      <div style="margin: 16px; margin-top: -10px;">
        <van-button round block @click="handleCancel">
          取消
        </van-button>
      </div>

      <!-- 加载遮罩 -->
      <van-overlay :show="loading">
        <div class="loading-wrapper">
          <van-loading size="24px">提交中...</van-loading>
        </div>
      </van-overlay>
    </van-form>
  </div>
</template>

<style scoped>
.page-loading-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f2f5;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
}
</style>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { getPhoneBankDetail, addPhoneBankFollow } from '@/api/phoneBank'
import { useDict } from '@/utils/dict'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import DictSelect from '@/components/DictSelect.vue';

const route = useRoute()
const router = useRouter()
const { call_status: callStatusList, loadDicts } = useDict('call_status')

const phoneBankId = ref('')
const phoneBankDetail = ref({})
const loading = ref(false)
const pageLoading = ref(true)
const showContactTypePicker = ref(false)
const phoneList = ref([])
const formData = reactive({
  contactType: '',
  contactTypeLabel: '',
  callStatus: '0',
  callStatusLabel: '已接通',
  remark: ''
})
const contactTypeFieldName = {
  text: 'dictLabel',
  value: 'dictValue'
}

onMounted(() => {
  phoneBankId.value = route.query.phoneBankId
  initData()
})

function initData() {
  pageLoading.value = true
  Promise.all([
    loadDicts(),
    getPhoneBankDetail(phoneBankId.value)
  ]).then(([, phoneBankDetailResponse]) => {
    phoneBankDetail.value = phoneBankDetailResponse
    initPhoneList()
    pageLoading.value = false
  }).catch(error => {
    console.error('数据加载失败:', error)
    pageLoading.value = false
  })
}

function initPhoneList() {
  phoneList.value = []
  if (phoneBankDetail.value?.phone) {
    phoneList.value.push({
      dictLabel: phoneBankDetail.value.phone,
      dictValue: phoneBankDetail.value.phone
    })
    formData.contactType = phoneBankDetail.value.phone
    formData.contactTypeLabel = phoneBankDetail.value.phone
  }

  if (phoneBankDetail.value?.otherPhone && phoneBankDetail.value.otherPhone !== phoneBankDetail.value.phone) {
    phoneList.value.push({
      dictLabel: phoneBankDetail.value.otherPhone,
      dictValue: phoneBankDetail.value.otherPhone
    })
  }
}

function onContactTypeConfirm({ selectedOptions }) {
  formData.contactType = selectedOptions[0].dictValue
  formData.contactTypeLabel = selectedOptions[0].dictLabel
  showContactTypePicker.value = false
}

function handleSubmit() {
  if (!formData.callStatus) {
    message.warning('请选择通话状态')
    return
  }

  const submitData = {
    phoneBankId: phoneBankId.value,
    callStatus: formData.callStatus,
    remark: formData.remark,
    callPhone: formData.contactType,
    nearlySchoolId: phoneBankDetail.value.nearlySchoolId,
    status: "1"
  }

  loading.value = true
  addPhoneBankFollow(submitData).then(() => {
    message.success('添加成功')
    router.back()
  }).catch(error => {
    message.error('添加失败，请重试')
    console.error('添加跟进记录失败:', error)
  }).finally(() => {
    loading.value = false
  })
}

function handleCancel() {
  router.back()
}
</script>

<style scoped>
/* 弹窗内容区域 */
.van-popup--bottom {
  background-color: #fff;
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
